var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38867 13.0508H8.61133C9.82422 13.0508 10.4277 12.4355 10.4277 11.2168V5.89648H6.18555C5.43555 5.89648 5.07812 5.53906 5.07812 4.78906V0.488281H2.38867C1.18164 0.488281 0.572266 1.10938 0.572266 2.32812V11.2168C0.572266 12.4414 1.17578 13.0508 2.38867 13.0508ZM6.20312 5.09375H10.3574C10.3223 4.85352 10.1523 4.61914 9.87109 4.33203L6.64258 1.04492C6.36719 0.763672 6.12695 0.59375 5.88086 0.552734V4.77734C5.88086 4.98828 5.98633 5.09375 6.20312 5.09375Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFile);
export default __webpack_public_path__ + "static/media/filled-file.1b51516a9a65f8f583b4f31a2e272362.svg";
export { ForwardRef as ReactComponent };